import { chatEvents } from "@/constants"
import { useCallback, useMemo, useRef, useState } from "react"

interface Props {
  refreshObserver: () => void
  scrollToBottom: () => void
}

export function useChatOpen(props: Props) {
  const { refreshObserver, scrollToBottom } = props

  const inputField = useRef<HTMLInputElement | null>(null)
  const previousFocus = useRef<HTMLElement | null>(null)

  const [isOpen, setIsOpen] = useState(false)

  const openChat = useCallback(() => {
    previousFocus.current = document.activeElement as HTMLElement
    setIsOpen(true)

    scrollToBottom()
    refreshObserver()
    requestAnimationFrame(() => {
      inputField.current?.focus()
    })
  }, [scrollToBottom, refreshObserver])

  const closeChat = useCallback(() => {
    setIsOpen(false)
    previousFocus.current?.focus()
    previousFocus.current = null
    window.postMessage({ type: chatEvents.CHAT_CLOSED }, "*")
  }, [])

  return useMemo(() => ({ openChat, closeChat, isOpen, inputField }), [openChat, closeChat, isOpen])
}
